import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import SignUp from '../Site/SignUp.js';
import {Link} from 'react-router-dom';
import { Button } from 'antd';
import background from '../../images/congruent_outline.png'

function HomeBanner(props){
  const style = {backgroundImage: 'url('+background+')',
  backgroundRepeat: 'repeat'};

  return (
    <section id="HomeBanner" style={style}>
      <SignUp>
        <Button
          icon="edit"
          >Create a Free Account!
        </Button>
      </SignUp>
    </section>
  )
}

export default HomeBanner;



// WEBPACK FOOTER //
// ./src/components/Home/HomeBanner.js